const BASE_URL = 'https://django-ldap.it.marist.edu/shopify/';
const CSRF_URL = BASE_URL + 'csrf/';
const AUTH_URL = BASE_URL + 'authenticate/';
const VERIFY_URL = BASE_URL + 'verify/';
const ACCESS_PAGE = '/pages/access';

const MESSAGE_STATUS = Object.freeze({
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning'
});
const MESSAGE_STATUS_COLORS = Object.freeze({
  [MESSAGE_STATUS.SUCCESS]: '#4F8A10',
  [MESSAGE_STATUS.ERROR]: '#c91235',
  [MESSAGE_STATUS.WARNING]: '#9F6000'
});
const EXTEND_NOTIFY_TIME_REMAINING = 15;
const IS_SHOPIFY_EDITOR = window.Shopify && window.Shopify.designMode;


async function getCSRFToken() {
  const response = await fetch(CSRF_URL, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Accept': 'application/json'
    }
  });

  if (!response.ok) {
    throw new Error(`CSRF request failed: HTTP ${response.status}`);
  }

  const data = await response.json();

  if (!data.csrfToken) {
    throw new Error('CSRF token was not returned.');
  }

  return data.csrfToken;
}


async function apiRequest(url, payload) {
  try {
    const token = await getCSRFToken();

    const response = await fetch(url, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRFToken': token
      },
      body: JSON.stringify(payload)
    });

    const data = await response.json();

    if (response.status === 429) {
      return {
        valid: false,
        status: MESSAGE_STATUS.ERROR,
        message: data.detail
                    ? 'ERROR: ' + data.detail
                    : 'ERROR: Request was throttled. Please wait before trying again.',
      };
    }

    return data;
  } catch (error) {
    return {
      valid: false,
      status: MESSAGE_STATUS.ERROR,
      message: 'Network error occurred. Please try again.'
    };
  }
}


async function authenticateCWID(cwid) {
  return await apiRequest(AUTH_URL, { cwid });
}


async function verifySession(session) {
  return await apiRequest(VERIFY_URL, { session });
}


function storeSession(data) {
  localStorage.setItem('techcommons_session', data.session);
  localStorage.setItem('techcommons_session_expires', data.expires_at);
}


function clearSession() {
  localStorage.removeItem('techcommons_session');
  localStorage.removeItem('techcommons_session_expires');
}


function redirectToAccess() {
  clearSession();
  window.location.href = ACCESS_PAGE;
}


window.addEventListener('load', function() {
  checkSessionExpiration();
});


document.addEventListener('submit', async function(event) {
  if (!event.target.matches('#cwid-form')) {
    return;
  }

  event.preventDefault();

  const cwid = document.getElementById('cwid').value.trim();

  if (!cwid) {
    return;
  }

  try {
    const data = await authenticateCWID(cwid);
    
    const accessMessage = document.getElementById('accessMessage');

    if (accessMessage) {
      accessMessage.innerText = data.message || '';

      accessMessage.classList.remove(
        MESSAGE_STATUS.SUCCESS,
        MESSAGE_STATUS.ERROR,
        MESSAGE_STATUS.WARNING
      );
      
      if (Object.values(MESSAGE_STATUS).includes(data.status)) {
        accessMessage.classList.add(data.status);

        accessMessage.style.background = MESSAGE_STATUS_COLORS[data.status];
      }

      if (data.message) {
        showAccessMessage();
      } else {
        hideAccessMessage();
      }
    }

    if (data.valid) {
      storeSession(data);
      
      window.location.href = '/';
    }

  } catch (error) {
    console.error('Authentication request failed:', error);
  }
});


document.addEventListener('DOMContentLoaded', function() {
  const cwidInput = document.querySelector('form#cwid-form #cwid');
  if (!cwidInput) { return; }

  cwidInput.addEventListener('input', function() {
    hideAccessMessage();
  });

  cwidInput.addEventListener('keydown', function (event) {
    if (
      event.key === '-' ||
      !/^[0-9]$/.test(event.key) &&
      ![
        'Backspace',
        'Delete',
        'ArrowLeft',
        'ArrowRight',
        'Tab',
        'Home',
        'End',
        'Enter'
      ].includes(event.key)
    ) {
      event.preventDefault();
    }
  });
});


(async function() {
  if (IS_SHOPIFY_EDITOR ||
    window.location.pathname === ACCESS_PAGE
  ) {
    document.documentElement.classList.remove('techcommons-auth-pending');
    return;
  }

  const session = localStorage.getItem('techcommons_session');

  if (!session) {
    redirectToAccess();
    return;
  }

  try {
    const data = await verifySession(session);

    if (!data.valid) {
      redirectToAccess();
      return;
    }

    // Store the returned session in case Django refreshes it.
    if (data.session) {
      storeSession(data);
    }

    // The page is safe to show. Remove the CSS hiding the content
    document.documentElement.classList.remove('techcommons-auth-pending');

  } catch (error) {
    console.error('Session validation failed:', error);
    redirectToAccess();
  }
})();


function checkSessionExpiration() {
  const expiresAt = localStorage.getItem('techcommons_session_expires');

  if (!expiresAt) {
    return;
  }

  const expiresTime = new Date(expiresAt).getTime();
  const now = Date.now();

  if (now >= expiresTime) {
    redirectToAccess();
    return;
  }

  const warningTime = expiresTime - (EXTEND_NOTIFY_TIME_REMAINING * 60 * 1000);

  if (now >= warningTime) {
    showSessionWarning();
    return;
  }

  setTimeout(showSessionWarning, warningTime - now);
}

function showSessionWarning() {
  if (document.getElementById('sessionWarning')) {
    return;
  }

  const warning = document.createElement('div');

  warning.id = 'sessionWarning';
  warning.innerHTML = `
  <button type="button" id="closeSessionWarning" aria-label="Close session warning">&times;</button>
  <div id="sessionMessage">
    Your session will expire in ` + EXTEND_NOTIFY_TIME_REMAINING + ` minutes and you will be logged out.
  </div>
  <div>
    <a href="#" id="extendSession">
      Click here to extend your session by another hour.
    </a>
  </div>
`;

  warning.style.position = 'fixed';
  warning.style.bottom = '20px';
  warning.style.right = '20px';
  warning.style.zIndex = '9999';
  warning.style.background = '#FFFFFF';
  warning.style.color = MESSAGE_STATUS_COLORS[MESSAGE_STATUS.ERROR];
  warning.style.borderRadius = '4px';
  warning.style.padding = '16px';
  warning.style.fontWeight = 'bold';
  warning.style.maxWidth = '350px';
  warning.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.25)';

  document.body.appendChild(warning);

  const closeSessionWarning = document.getElementById('closeSessionWarning');

  closeSessionWarning.style.position = 'absolute';
  closeSessionWarning.style.top = '4px';
  closeSessionWarning.style.right = '8px';
  closeSessionWarning.style.border = 'none';
  closeSessionWarning.style.background = 'transparent';
  closeSessionWarning.style.fontSize = '24px';
  closeSessionWarning.style.lineHeight = '1';
  closeSessionWarning.style.cursor = 'pointer';
  closeSessionWarning.style.color = '#000000';
  closeSessionWarning.style.padding = '0';

  closeSessionWarning.addEventListener('click', function() {
    warning.remove();
  });

  const sessionMessage = document.getElementById('sessionMessage');

  sessionMessage.style.paddingTop = '8px';

  const extendSessionLink = document.getElementById('extendSession');

  extendSessionLink.style.marginTop = '16px';
  extendSessionLink.style.display = 'block';
  extendSessionLink.style.textDecorationColor = 'inherit';
  extendSessionLink.style.color = '#006E7A';

  extendSessionLink.addEventListener('click', async function(event) {
    event.preventDefault();

    const session = localStorage.getItem('techcommons_session');

    if (!session) {
      redirectToAccess();
      return;
    }

    try {
      const data = await verifySession(session);

      if (data.valid) {
        storeSession(data);

        warning.remove();

        checkSessionExpiration();
      } else {
        redirectToAccess();
      }
    } catch (error) {
      console.error('Session extension failed:', error);
    }
  });
}

function hideAccessMessage() {
  const accessMessage = document.getElementById('accessMessage');

  if (accessMessage) {
    accessMessage.style.display = 'none';
  }
}


function showAccessMessage() {
  const accessMessage = document.getElementById('accessMessage');

  if (accessMessage) {
    accessMessage.style.display = 'block';
  }
}